<template>
  <a href="/#/perguntas-frequentes" target="_blank">
    {{ $t("helpers.chat.access_faq") }}
  </a>
</template>

<script>
export default {
  name: "HelpFAQComponent",
};
</script>

<style lang="scss" scoped></style>
